module.exports = __webpack_public_path__ + "img/cluster1.03c08d8.jpg";